import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AutoLinker from "autolinker";

export default function AlertDialog(props) {
  return (
    <Dialog
      id="alert-dialog-box"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.marker.name}</DialogTitle>
      <DialogContent id="alert-dialog-description-box">
        <DialogContentText id="alert-dialog-description">
          <p dangerouslySetInnerHTML={{ __html: props.marker.description }}/>

          {props.marker.properties.map((property, index) => {
            let valueText = AutoLinker.link(property.value);
            return (
              <div key={index}>
                <h5>{property.key}</h5>
                <p dangerouslySetInnerHTML={{ __html: valueText }} />
              </div>
            );
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions id="alert-dialog-button-box">
        <Button
          onClick={props.onClose}
          color="primary"
          id="alert-dialog-button"
          autoFocus
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
}
